const carousels = async function () {
    const singleInvestmentRelated = [...document.querySelectorAll(".single-investment-related")];
    const homeHero = [...document.querySelectorAll(".home-hero")];

    if (singleInvestmentRelated || homeHero) {
        const Swiper = await (await import("swiper/bundle")).default;

        if (homeHero) {
            homeHero.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    autoplay: {
                        delay: 4000,
                    },
                    spaceBetween: 0,
                    slidesPerView: 1,
                    loop: true,
                    simulateTouch: false,
                    allowTouchMove: false,
                    noSwiping: false,
                    speed: 1000,
                    touchRatio: 0,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    lazy: true,
                    on: {
                        slideChange: (swiper) => {
                            const image = section.querySelectorAll("img")[swiper.activeIndex + 1];
                            if ( image ) image.style.display = "block";
                        }
                    }
                });

                carousel.autoplay.stop();

                setTimeout(() => {
                    carousel.autoplay.start();
                }, 5000)
            })
        }

        if (singleInvestmentRelated) {
            singleInvestmentRelated.forEach(section => {
                const next =  section.querySelector(".next-invest"),
                    prev = section.querySelector(".prev-invest");

                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: 1,
                    spaceBetween: 28,
                    breakpoints: {
                        576: {
                            slidesPerView: 1.5,
                            spaceBetween: 28,
                        },
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 28,
                        },
                        1024: {
                            slidesPerView: 2.5,
                            spaceBetween: 28,
                        },
                    },
                    navigation: {
                        prevEl: prev,
                        nextEl: next,
                    },
                    on: {
                        init: function () {
                            prev.classList.add("unactive");
                        },
                        reachEnd: function () {
                            next.classList.add("unactive");
                        },
                        reachBeginning: function () {
                            prev.classList.add("unactive");
                        },
                        fromEdge: function () {
                            prev.classList.remove("unactive");
                            next.classList.remove("unactive");
                        },
                    }
                });
            })
        }
    }
}

export const init = carousels;